import { createContext, useContext, useMemo, type ReactNode } from "react";
import type { DensityMode, Direction, ThemeMode } from "./types";

type ThemeContextValue = { theme: ThemeMode; density: DensityMode; direction: Direction };
const ThemeContext = createContext<ThemeContextValue>({ theme: "light", density: "comfortable", direction: "rtl" });

export function ThemeProvider({ theme = "light", density = "comfortable", direction = "rtl", children, className = "" }: { theme?: ThemeMode; density?: DensityMode; direction?: Direction; children: ReactNode; className?: string }) {
  const value = useMemo(() => ({ theme, density, direction }), [theme, density, direction]);
  return <ThemeContext.Provider value={value}><div className={`nx-theme-root ${className}`.trim()} data-theme={theme} data-density={density} dir={direction}>{children}</div></ThemeContext.Provider>;
}
export function useLeylionTheme() { return useContext(ThemeContext); }
/** @deprecated Use useLeylionTheme. Kept only for source compatibility. */
export const useNovexTheme = useLeylionTheme;
